import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    fontFamily: 'Raleway',
    fontSize: '12px',
    color: '#6a27e8',
    marginTop: '10px',
    marginBottom: '10px',
  },
  copyright: {
    marginRight: '4px',
  },
  link: {
    fontFamily: 'Raleway',
    fontSize: '12px',
    color: '#6a27e8',
    textDecoration: 'none',
    marginLeft: '4px',
  },
});

const Copyright = ({ classes }) => (
  <Typography className={classes.root} align="center">
    <b className={classes.copyright}>SlashData © Copyright 2019</b>
| All rights
    reserved |
    <Link to="/cookie-policy" className={classes.link}>
      Cookie Policy |
    </Link>
    <Link to="/privacy" className={classes.link}>
      Privacy Policy
    </Link>
  </Typography>
);

Copyright.propTypes = {
  classes: PropTypes.shape().isRequired,
};

export default withStyles(styles)(Copyright);
